export default {
  searching: 'Buscando',
}
